import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { AcornsIcon } from '@acorns/icons';
import { Bodytext } from '../Typography';
import { ReadMoreButton, StyledChevron } from './styled-components';
import { ChevronDirection } from './constants';
export var ReadMore = function ReadMore(_ref) {
  var text = _ref.text,
      maxTextLength = _ref.maxTextLength,
      _ref$expandTextName = _ref.expandTextName,
      expandTextName = _ref$expandTextName === void 0 ? 'Read more' : _ref$expandTextName,
      _ref$shrinkTextName = _ref.shrinkTextName,
      shrinkTextName = _ref$shrinkTextName === void 0 ? 'Read less' : _ref$shrinkTextName,
      isExpanded = _ref.isExpanded,
      handleReadMore = _ref.handleReadMore,
      testId = _ref.testId,
      className = _ref.className;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpandedDefault = _useState2[0],
      setIsExpandedDefault = _useState2[1];

  if (!handleReadMore || isExpanded === undefined) {
    handleReadMore = function handleReadMore() {
      setIsExpandedDefault(!isExpandedDefault);
    };

    isExpanded = isExpandedDefault;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, text.length <= maxTextLength ? /*#__PURE__*/React.createElement(Bodytext, null, text) : isExpanded ? /*#__PURE__*/React.createElement(Bodytext, null, text) : /*#__PURE__*/React.createElement(Bodytext, null, text.slice(0, maxTextLength), "..."), text.length > maxTextLength && /*#__PURE__*/React.createElement(ReadMoreButton, {
    "data-testid": testId,
    onClick: handleReadMore
  }, isExpanded ? shrinkTextName : expandTextName, /*#__PURE__*/React.createElement(StyledChevron, {
    icon: AcornsIcon.Icon.RightChevron,
    width: "12px",
    height: "12px",
    direction: isExpanded ? ChevronDirection.Up : ChevronDirection.Down
  })));
};